module.exports = __webpack_public_path__ + "img/45.70221136.png";